import { twMerge } from "tailwind-merge";

import {
  PATIENT_LIST_PROVIDER_FILTERS,
  PatientListProviderFilters,
} from "~/providers/utils";

interface FilterOwnConsultationsButtonProps {
  filter: PatientListProviderFilters;
  disabled?: boolean;
  onFilterChanged: (value: PatientListProviderFilters) => void;
}
export const FilterOwnConsultationsButton = ({
  filter,
  disabled = false,
  onFilterChanged,
}: FilterOwnConsultationsButtonProps) => {
  return (
    <div className={twMerge("text-sm", disabled && "opacity-50")}>
      <button
        disabled={disabled}
        className={twMerge(
          "inline-flex h-11 items-center rounded-l-lg border border-gray-200 p-3 text-gray-700",
          filter === PATIENT_LIST_PROVIDER_FILTERS.all &&
            "border-blue-600 bg-blue-100 font-medium text-blue-600",
          filter != PATIENT_LIST_PROVIDER_FILTERS.all && "hover:bg-neutral-150",
        )}
        onClick={() => onFilterChanged(PATIENT_LIST_PROVIDER_FILTERS.all)}
      >
        All
      </button>
      <button
        disabled={disabled}
        className={twMerge(
          "inline-flex h-11 items-center border border-x-0 border-gray-200 p-3 text-gray-700",
          filter === PATIENT_LIST_PROVIDER_FILTERS.unassigned &&
            "border-x border-blue-600 bg-blue-100 font-medium text-blue-600",
          filter != PATIENT_LIST_PROVIDER_FILTERS.unassigned &&
            "hover:bg-neutral-150",
        )}
        onClick={() =>
          onFilterChanged(PATIENT_LIST_PROVIDER_FILTERS.unassigned)
        }
      >
        Unassigned
      </button>
      <button
        disabled={disabled}
        className={twMerge(
          "inline-flex h-11 items-center rounded-r-lg border border-gray-200 p-3 text-gray-700",
          filter === PATIENT_LIST_PROVIDER_FILTERS.me &&
            "border-blue-600 bg-blue-100 font-medium text-blue-600",
          filter != PATIENT_LIST_PROVIDER_FILTERS.me && "hover:bg-neutral-150",
        )}
        onClick={() => onFilterChanged(PATIENT_LIST_PROVIDER_FILTERS.me)}
      >
        My consultations
      </button>
    </div>
  );
};
